function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M119.5 66C119.5 95.5472 95.5472 119.5 66 119.5C36.4528 119.5 12.5 95.5472 12.5 66C12.5 36.4528 36.4528 12.5 66 12.5C95.5472 12.5 119.5 36.4528 119.5 66Z",
  stroke: "#009688",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M54.9999 80.245L89.6499 45.595C90.7084 44.7009 92.0653 44.2392 93.4495 44.3023C94.8336 44.3654 96.1429 44.9485 97.1157 45.9352C98.0884 46.9218 98.653 48.2393 98.6964 49.6242C98.7398 51.0091 98.259 52.3593 97.3499 53.405L58.8499 91.905C57.8218 92.9127 56.4396 93.4772 54.9999 93.4772C53.5603 93.4772 52.1781 92.9127 51.1499 91.905L34.6499 75.405C33.7409 74.3593 33.2601 73.0091 33.3035 71.6242C33.3469 70.2393 33.9114 68.9218 34.8842 67.9352C35.857 66.9485 37.1663 66.3654 38.5504 66.3023C39.9345 66.2392 41.2915 66.7009 42.3499 67.595L54.9999 80.245Z",
  fill: "#009688"
});

var SvgIconConfirmCheck = function SvgIconConfirmCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconConfirmCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-confirm-check.e91f9e78.svg";
export { ForwardRef as ReactComponent };